import { render } from "./SingleDoctor.vue?vue&type=template&id=7f5d50ef"
import script from "./SingleDoctor.vue?vue&type=script&lang=js"
export * from "./SingleDoctor.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__